/* eslint-disable max-len */
<template>
  <div id="app">
   <v-app light>
     <Header class="hidden-sm-and-down" />
     <HeaderMobile class="hidden-md-and-up" />
      <FirstParallax id="uns" />
      <Values />
      <SecondParallax id="keller"/>
      <KellerInfo />
      <ThirdParallax id="wg" />
      <WGInfo />
      <Contact id="kontakt"/>
  </v-app>
 </div>
</template>

<script>
import Header from '../components/molecules/Header.vue';
import HeaderMobile from '../components/molecules/HeaderMobile.vue';

import FirstParallax from '../components/molecules/FirstParallax.vue';
import Values from '../components/molecules/Values.vue';
import SecondParallax from '../components/molecules/SecondParallax.vue';
import KellerInfo from '../components/molecules/KellerInfo.vue';
import ThirdParallax from '../components/molecules/ThirdParallax.vue';
import WGInfo from '../components/molecules/WGInfo.vue';
import Contact from '../components/molecules/Contact.vue';


export default {
  components: {
    Header,
    HeaderMobile,
    FirstParallax,
    Values,
    SecondParallax,
    KellerInfo,
    ThirdParallax,
    WGInfo,
    Contact,
  },
  data: () => ({

  }),
};
</script>

<style>
.parallax img { width: 100%; }
</style>
